import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import FlexibleCancellationPolicyTimelineContent from './FlexibleCancellationPolicyTimelineContent'
import type { FlexibleCancellationTimelineDetails } from './flexibleCancellationPolicyTimelineUtils'

export interface Props {
  details: FlexibleCancellationTimelineDetails
  /** Whether this is a charter bundle (flights + hotel). Affects terminology and shows charter-specific fees. */
  isCharter?: boolean
}

function OfferPropertyFlexibleCancellationPolicyTimelineModal(props: Props) {
  const { details, isCharter } = props
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'ip9FOw9dQ_KIKaoEbQDw',
        defaultMessage: 'Cancellation policy',
      })}
    >
      <FlexibleCancellationPolicyTimelineContent
        details={details}
        isCharter={isCharter}
      />
    </Modal>
  )
}

export default OfferPropertyFlexibleCancellationPolicyTimelineModal
